module.exports = __webpack_public_path__ + "media/3-4.09612571.wav";